export default __webpack_public_path__ + "static/media/jb.a690977d.jpg";